<template>
  <div class="card card-custom card-stretch gutter-b">
    <!--begin::Body-->
    <div class="card-body d-flex flex-column">
      <div class="flex-grow-1 pb-5">
        <!--begin::Info-->
        <h1 style="text-transform: uppercase">{{ pageTitle }}</h1>
        <div class="d-flex align-items-center mb-6">
          <span class="text-muted font-weight-bold font-size-lg flex-grow-1"
            >Kundeninformationen</span
          >
        </div>
        <!--end::Info-->

        <div class="vld-parent">
          <loading
            :active.sync="isLoading"
            :can-cancel="true"
            :is-full-page="true"
          ></loading>
        </div>

        <v-app>
          <v-container>
            <v-row style="margin-top: 25px;">
              <v-col cols="12" class="d-flex justify-end text-center">
                <v-btn
                  class="primary custom_button"
                  large
                  height="50"
                  style="margin-right: 15px;"
                  @click="openNewClient"
                >
                  <v-icon left>mdi-plus</v-icon>
                  Neuen Kunden
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Suchen Sie hier nach einem Kunden"
                    hide-details
                    clearable
                    @keypress="getDataFromApi"
                  ></v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="clients"
                  :options.sync="options"
                  :server-items-length="totalClients"
                  sort-by="CompanyName"
                  class="table1"
                  :loading="loadingVariable"
                  :search="search"
                  loading-text="Bitte warten... Kunden werden geladen"
                  :items-per-page="-1"
                  :disable-pagination="true"
                >
                  <template v-slot:footer.page-text="items">
<!--                    {{ items.pageStart }} von {{ items.itemsLength }}  Kunde möchte kein Paginator haben -->
                    Gesamtanzahl der Kunden: {{ items.itemsLength }}
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <div class="actions-inline">
                      <v-tooltip top attach="" dense color="primary">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            class="mr-2"
                            @click="toClientItems(item)"
                            text="test"
                            style="font-size: 20px;"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-percent
                          </v-icon>
                        </template>
                        <span>Artikel-Preisverwaltung</span>
                      </v-tooltip>
                      <v-tooltip top attach="" dense color="primary">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            class="mr-2"
                            v-bind="attrs"
                            v-on="on"
                            style="font-size: 20px;"
                            @click="openStatsDialog(item)"
                          >
                            mdi-chart-arc
                          </v-icon>
                        </template>
                        <span>Statistik herunterladen</span>
                      </v-tooltip>
                      <v-tooltip top attach="" dense color="primary">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            title="Edit user"
                            class="mr-2"
                            @click="editItem(item)"
                            text="test"
                            style="font-size: 20px;"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-pencil
                          </v-icon>
                        </template>
                        <span>Editieren</span>
                      </v-tooltip>
                      <v-tooltip top attach="" dense color="primary">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            title="Edit user"
                            class="mr-2"
                            @click="deleteClient(item)"
                            text="test"
                            style="font-size: 20px;"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <span>Löschen</span>
                      </v-tooltip>
                    </div>
                  </template>
                  <template v-slot:no-data>
                    Kein Kunde vorhanden
                  </template>
                  <!--                  <template v-slot:no-data>-->
                  <!--                    <div>Please choose a sender</div>-->
                  <!--                  </template>-->
                </v-data-table>
              </v-col>
            </v-row>

            <v-dialog v-model="statsDialog" max-width="520px">
              <v-card>
                <v-card-title class="m-2 mb-2">
                  <span class="headline">Statistik herunterladen</span>
                </v-card-title>
                <v-card-text>
                  <div class="text-muted mb-2" v-if="statsClient">
                    Kunde: {{ statsClient.CompanyName }}
                  </div>
                  <v-radio-group v-model="statsBreakdown" row>
                    <v-radio label="Statistik in Monaten" value="month"></v-radio>
                    <v-radio label="Statistik in KW" value="week"></v-radio>
                  </v-radio-group>
                  <v-radio-group v-model="statsFormat" row>
                    <v-radio label="PDF" value="pdf"></v-radio>
                    <v-radio label="Excel (XLSX)" value="xlsx"></v-radio>
                  </v-radio-group>
                  <v-select
                    v-model="statsYear"
                    :items="statsYears"
                    label="Jahr"
                    filled
                    dense
                    background-color="#f7f7f7"
                  ></v-select>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="closeStatsDialog">Abbrechen</v-btn>
                  <v-btn color="primary" @click="confirmStatsDownload">Download</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialog" max-width="1200px">
              <!--              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" class="mb-2" v-bind="attrs" v-on="on">
                  Create new client
                </v-btn>
              </template>-->
              <v-card>
                <v-card-title class="m-2 mb-6">
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" lazy-validation>
                      <v-row>
                        <v-col cols="9" class="client-section-heading">
                          <h3 class="mb-1">Kundendaten</h3>
                          <div class="helptext">
                            Allgemeine Angaben, Anschrift und Kontaktdaten des
                            Kunden.
                          </div>
                        </v-col>
                        <v-col cols="9" sm="9" md="9">
                          <v-text-field
                            v-model="editedItem.Customer_ID"
                            label="Kundennummer*"
                            filled
                            auto-grow
                            background-color="#f7f7f7"
                            name="input-7-1"
                            dense
                            clearable
                            :rules="[rules.required, rules.integer]"
                            :disabled="editedIndex > -1"
                            type="number"
                            inputmode="numeric"
                            pattern="\\d*"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="9" sm="9" md="9">
                          <v-text-field
                            v-model="editedItem.CompanyName"
                            label="Name des Unternehmens*"
                            filled
                            auto-grow
                            background-color="#f7f7f7"
                            name="input-7-1"
                            dense
                            clearable
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="9" sm="9" md="9">
                          <v-text-field
                            v-model="editedItem.CompanyName2"
                            label="Namenszusatz*"
                            filled
                            auto-grow
                            background-color="#f7f7f7"
                            name="input-7-1"
                            dense
                            clearable
                          ></v-text-field>
                        </v-col>
                        <v-col cols="9" sm="9" md="9">
                          <v-text-field
                            v-model="editedItem.ExternalID"
                            label="Externe ID Nummer*"
                            filled
                            auto-grow
                            background-color="#f7f7f7"
                            name="input-7-1"
                            dense
                            clearable
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="9" sm="9" md="9">
                          <v-text-field
                            v-model="editedItem.Street"
                            label="Straße*"
                            filled
                            auto-grow
                            background-color="#f7f7f7"
                            name="input-7-1"
                            dense
                            clearable
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="4" sm="4" md="4">
                          <v-text-field
                            v-model="editedItem.PostalCode"
                            label="PLZ*"
                            filled
                            auto-grow
                            background-color="#f7f7f7"
                            name="input-7-1"
                            dense
                            clearable
                            type="text"
                            maxlength="12"
                            :rules="[rules.required, validatePostalCode]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="4" sm="4" md="4">
                          <v-text-field
                            v-model="editedItem.City"
                            label="Stadt*"
                            filled
                            auto-grow
                            background-color="#f7f7f7"
                            name="input-7-1"
                            dense
                            clearable
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <v-text-field
                            v-model="editedItem.CountryCode"
                            label="Ländercode*"
                            filled
                            auto-grow
                            background-color="#f7f7f7"
                            name="input-7-1"
                            dense
                            clearable
                            maxlength="2"
                            :rules="[rules.required, validateCountryCode]"
                            @blur="normalizeCountryCode"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="9" sm="9" md="9">
                          <v-text-field
                            v-model="editedItem.VATNumber"
                            label="USt-IdNr."
                            filled
                            background-color="#f7f7f7"
                            dense
                            clearable
                            maxlength="20"
                            :rules="[validateVatNumber]"
                            @blur="normalizeVatNumber"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="editedItem.ContactPerson"
                            label="Kontaktperson"
                            filled
                            auto-grow
                            background-color="#f7f7f7"
                            name="input-7-1"
                            dense
                            clearable
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="editedItem.InvoiceMail"
                            label="E-Mail Buchhaltung*"
                            filled
                            auto-grow
                            background-color="#f7f7f7"
                            name="input-7-1"
                            dense
                            clearable
                            :rules="[rules.email, rules.required]"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="10" class="">
                          <v-alert
                              dense
                              outlined
                              type="info"
                          >
                            Hinweis: Die primäre und sekundäre E-Mail-Adresse werden zusätzlich im <strong>Besuchsbericht</strong> als Empfänger verwendet.
                             <br>
                          </v-alert>
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="editedItem.ContactMail"
                            label="E-Mail-Kontaktadresse (primär)*"
                            filled
                            auto-grow
                            background-color="#f7f7f7"
                            name="input-7-1"
                            dense
                            clearable
                            :rules="[rules.email, rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="editedItem.ContactMailSecondary"
                            label="E-Mail-Kontaktadresse (sekundär)"
                            filled
                            auto-grow
                            background-color="#f7f7f7"
                            name="input-7-1"
                            dense
                            clearable
                            :rules="[rules.email]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="9" sm="9" md="9">
                          <v-text-field
                            v-model="editedItem.Iban"
                            label="IBAN (für SEPA-Lastschriftmandat erforderlich)"
                            filled
                            auto-grow
                            background-color="#f7f7f7"
                            name="input-7-1"
                            dense
                            clearable
                            :rules="[rules.iban]"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="9"
                          class="client-section-heading client-section-heading--settings"
                        >
                          <h3 class="mb-1">Einstellungen</h3>
                          <div class="helptext">
                            Voreinstellungen für neue Rechnungen und weitere
                            Abläufe dieses Kunden.
                          </div>
                        </v-col>
                        <v-col class="ml-2" cols="9" sm="9" md="9">
                          <h4 class="mb-1">Standard-Steuerbehandlung</h4>
                          <div class="helptext">
                            Diese Steuerbehandlung wird beim ersten Laden des
                            Kunden in einer neuen Rechnung vorausgewählt.
                          </div>
                        </v-col>
                        <v-col cols="9" sm="9" md="9">
                          <v-select
                            v-model="editedItem.default_tax_type_id"
                            :items="taxTypeOptions"
                            item-text="name"
                            item-value="id"
                            label="Umsatzsteuerliche Behandlung"
                            filled
                            dense
                            background-color="#f7f7f7"
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                        <v-col class="ml-2" cols="9" sm="9" md="9">
                          <h4 class="mb-1">Standard-Zahlungsmodalität</h4>
                          <div class="helptext">
                            Diese Zahlungsmodalität wird beim ersten Laden des
                            Kunden in einer neuen Rechnung automatisch
                            vorausgewählt.
                          </div>
                        </v-col>
                        <v-col cols="9" sm="9" md="9">
                          <v-select
                            v-model="editedItem.payment_fixed_text_id"
                            :items="fixedTextOptions"
                            item-text="short"
                            item-value="id"
                            label="Zahlungsmodalität"
                            filled
                            dense
                            background-color="#f7f7f7"
                          >
                            <template slot="item" slot-scope="data">
                              {{ data.item.short + ' - ' + (data.item.description.length > 45 ? data.item.description.slice(0, 45) + '...' : data.item.description) }}
                            </template>
                          </v-select>
                        </v-col>
                        <v-col class="ml-2" cols="9" sm="9" md="9">
                          <h4 class="mb-1">Voreinstellung für die Rechnungsstatistik</h4>
                          <div class="helptext">Legen Sie fest, in welcher Aufbereitung die an die Rechnung angehängte Statistik standardmäßig erzeugt wird: nach Kalenderwochen oder monatlich.</div>
                        </v-col>
                        <v-col cols="9" sm="9" md="9">
                          <v-select
                            v-model="editedItem.report_frequency"
                            :items="reportFrequencyItems"
                            item-text="text"
                            item-value="value"
                            label="Voreinstellung (KW/Monat)"
                            filled
                            dense
                            background-color="#f7f7f7"
                          ></v-select>
                        </v-col>
                        <v-col cols="9" sm="9" md="9">
                          <v-switch
                              v-model="editedItem.sync_enabled"
                              inset
                              :true-value="1"
                              :false-value="0"
                              label="Sync aktiv (Kunde wird automatisch mit dem Portal abgeglichen)"
                          ></v-switch>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <div v-if="formInvalid" class="fillAllFieldsMessage">
                            {{ formInvalidMessage }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              class="mr-4 p-7"
                              color="btn2"
                              @click="close()"
                            >
                              Schließen
                            </v-btn>
                            <v-btn class="p-7" color="primary" @click="save()">
                              Speichern
                            </v-btn>
                          </v-card-actions>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-container>
        </v-app>
      </div>
    </div>
  </div>
</template>
<style>
.v-data-footer__select {
  display: none !important;
}
.custom_button.theme--light.v-btn.v-btn--disabled {
  background-color: lightgray !important;
}
.fillAllFieldsMessage {
  color: red;
}
.client-section-heading {
  margin-left: 8px;
}
.client-section-heading--settings {
  margin-top: 28px;
  padding-top: 24px !important;
  border-top: 1px solid #dfe5e1;
}
.client-section-heading h3 {
  color: #2d3748;
  font-size: 18px;
  font-weight: 600;
}
.helptext { font-size: 12px; color: #6b7280; }
.actions-inline { display: flex; align-items: center; gap: 1px; white-space: nowrap; }
.actions-inline > * { display: inline-flex; }
.actions-inline .v-tooltip, .actions-inline .v-menu { display: inline-flex; }
.actions-inline .v-icon { line-height: 1; }
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/core/services/api.service";
// eslint-disable-next-line no-unused-vars
import { LOGIN, LOGOUT } from "@/core/services/store/auth.module";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Vue from "vue";
import Swal from "sweetalert2";
Vue.use(Loading);

const createEmptyClient = () => ({
  id: "",
  ExternalID: "",
  Customer_ID: "",
  CompanyName: "",
  report_frequency: "month",
  CompanyName2: "",
  Street: "",
  Street2: "",
  PostalCode: "",
  City: "",
  CountryCode: "",
  ContactPerson: "",
  InvoiceMail: "",
  InternalInvoiceMail: "",
  ContactMail: "",
  ContactMailSecondary: "",
  VATNumber: "",
  Iban: "",
  payment_fixed_text_id: 1,
  default_tax_type_id: null,
  sync_enabled: 0
});

export default {
  name: "clients",
  components: { Loading },
  data: function() {
    return {
      pageTitle: "Kundenansicht",
      dialog: false,
      loadingVariable: false,
      search: "",
      headers: [
        { text: "Ext.Nr.", value: "ExternalID" },
        { text: "K-Nr.", value: "Customer_ID" },
        { text: "Kundenname", value: "CompanyName" },
        { text: "Kontaktperson", value: "ContactPerson" },
        { text: "Straße", value: "Street" },
        { text: "Stadt", value: "City" },
        { text: "Optionen", value: "actions", sortable: false , width: "120px"}
      ],
      totalClients: 0,
      options: { page: 1 },
      clients: {},
      editedIndex: -1,
      editedItem: createEmptyClient(),
      formInvalidMessage: "*Bitte alle Pflichtfelder befüllen",
      formInvalid: false,
      fixedTextOptions: [],
      taxTypeOptions: [],
      reportFrequencyItems: [
        { text: 'Monatlich (Standard)', value: 'month' },
        { text: 'Wöchentlich', value: 'week' }
      ],
      rules: {
        fullPage: false,
        required: value => !!value || "Pflichtfeld.",
        formHasErrors: false,
        min: v => (v && v.length >= 8) || "Min 8 Zeichen",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return value ? pattern.test(value) || "Ungültige E-Mail." : true;
        },
        iban: value => {
          if (!value) return true; // Kein Pflichtfeld? Dann true zurückgeben.
          const pattern = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/;
          return pattern.test(value.replace(/\s+/g, '').toUpperCase()) || "Ungültige IBAN.";
        },
        integer: v => (v === 0 || v === "0" || (!!v && /^\d+$/.test(String(v)))) || "Nur ganze Zahlen (0-9).",
      },
      isLoading: false,
      statsDialog: false,
      statsClient: null,
      statsBreakdown: "month",
      statsFormat: "pdf",
      statsYearStart: 2025,
      statsYear: new Date().getFullYear()
    };
  },
  created() {
    this.clients = [];
    this.getDataFromApi();
    this.loadFixedTexts();
    this.loadTaxTypes();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Overview" }]);
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Kundeninformationen editieren"
        : "Kundeninformationen";
    },
    statsYears() {
      const current = this.getCurrentYear();
      const start = this.statsYearStart;
      const end = Math.max(current, start);
      const years = [];
      for (let y = end; y >= start; y -= 1) {
        years.push(y);
      }
      return years;
    }
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi();
      },
      deep: true
    },
    dialog(val) {
      val || this.close();
    }
  },
  methods: {
    openNewClient() {
      this.resetForm();
      this.editedIndex = -1;
      this.editedItem.default_tax_type_id = this.getStandardTaxTypeId();
      this.dialog = true;
    },
    loadTaxTypes() {
      ApiService.query("taxtypes")
        .then(({ data }) => {
          this.taxTypeOptions = data.tax_types || [];
          if (!this.editedItem.default_tax_type_id) {
            this.editedItem.default_tax_type_id = this.getStandardTaxTypeId();
          }
        })
        .catch(() => {
          this.taxTypeOptions = [];
        });
    },
    getStandardTaxTypeId() {
      const standard = this.taxTypeOptions.find(
        taxType => taxType.code === "STANDARD_19"
      );
      return standard ? standard.id : null;
    },
    selectedDefaultTaxType() {
      return this.taxTypeOptions.find(
        taxType =>
          Number(taxType.id) === Number(this.editedItem.default_tax_type_id)
      );
    },
    normalizeCountryCode() {
      this.editedItem.CountryCode = String(this.editedItem.CountryCode || "")
        .trim()
        .toUpperCase();
    },
    normalizeVatNumber() {
      this.editedItem.VATNumber = String(this.editedItem.VATNumber || "")
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");
    },
    validateCountryCode(value) {
      return (
        /^[A-Za-z]{2}$/.test(String(value || "")) ||
        "Bitte einen zweistelligen ISO-Ländercode angeben."
      );
    },
    validatePostalCode(value) {
      const postalCode = String(value || "").trim();
      const countryCode = String(
        this.editedItem.CountryCode || ""
      ).toUpperCase();

      if (countryCode === "DE") {
        return (
          /^\d{5}$/.test(postalCode) ||
          "Eine deutsche PLZ muss aus 5 Ziffern bestehen."
        );
      }
      if (countryCode === "PL") {
        return (
          /^\d{2}-?\d{3}$/.test(postalCode) ||
          "Eine polnische PLZ muss dem Format 00-000 entsprechen."
        );
      }

      return (
        /^[A-Za-z0-9][A-Za-z0-9 -]{1,11}$/.test(postalCode) ||
        "Ungültige internationale Postleitzahl."
      );
    },
    validateVatNumber(value) {
      const taxType = this.selectedDefaultTaxType();
      const vatNumber = String(value || "")
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");

      if (!vatNumber && (!taxType || taxType.code !== "EU_INTRA_COMMUNITY")) {
        return true;
      }
      if (!/^[A-Z]{2}[A-Z0-9]{2,12}$/.test(vatNumber)) {
        return "Bitte eine gültig formatierte USt-IdNr. angeben.";
      }

      const countryCode = String(
        this.editedItem.CountryCode || ""
      ).toUpperCase();
      const expectedPrefix = countryCode === "GR" ? "EL" : countryCode;
      return (
        vatNumber.slice(0, 2) === expectedPrefix ||
        "Die USt-IdNr. passt nicht zum Ländercode."
      );
    },
    getDataFromApi() {
      this.loadingVariable = true;
      ApiService.query(
          //Paginator wurde ausgeschaltet -> Kundenwunsch
          //"/clients?page=" + this.options.page + "&search=" + this.search
          "/clients?search=" + this.search
      )
        .then(({ data }) => {
          this.loadingVariable = false;
          this.clients = data.clients;
          this.totalClients = data.clients.total;
        })
        .catch(({ response }) => {
          if (response.status === 401) {
            if (response.status === 401) {
              this.loadingVariable = false;
              this.$store
                .dispatch(LOGOUT)
                .then(() => this.$router.push({ name: "login" }));
            }
          }
        });
    },
    deleteClient(client) {
      Swal.fire({
        title: "Kunden löschen",
        text: "Möchten Sie diesen Kunden wirklich löschen?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        confirmButtonText: "Löschen",
        cancelButtonText: "Abbrechen"
      }).then(invoice => {
        if (invoice.value) {
          this.isLoading = true;
          ApiService.delete("clients/" + client.id)
            .then(() => {
              location.reload();
            })
            .catch(({ response }) => {
              if (response.status === 401) {
                if (response.status === 401) {
                  this.$store
                    .dispatch(LOGOUT)
                    .then(() => this.$router.push({ name: "login" }));
                }
              }
              this.isLoading = false;
            });
        }
      });
    },
    close() {
      this.dialog = false;
      this.formInvalid = false;
      this.formInvalidMessage = "";
      this.$nextTick(() => {
        this.editedItem = createEmptyClient();
        this.editedIndex = -1;
      });
    },
    editItem(item) {
      this.editedIndex = this.clients.indexOf(item);
      this.editedItem = Object.assign(createEmptyClient(), item);
      if (item.payment_fixed_text_id === null) {
        this.editedItem.payment_fixed_text_id = null;
      }
      if (!this.editedItem.default_tax_type_id) {
        this.editedItem.default_tax_type_id = this.getStandardTaxTypeId();
      }
      this.dialog = true;
    },
    save() {
      if (this.$refs.form.validate()) {
        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: true,
          onCancel: this.onCancel
        });
        // Kundennummer nur Ziffern
        if (this.editedItem && this.editedItem.Customer_ID !== undefined && this.editedItem.Customer_ID !== null) {
          this.editedItem.Customer_ID = String(this.editedItem.Customer_ID).replace(/\D/g, "");
        }
        this.normalizeCountryCode();
        this.normalizeVatNumber();
        if (this.editedIndex > -1) {
          ApiService.put("clients/update", this.editedItem)
            .then(response => {
              let client = response.data.client;
              if (client) {
                Object.assign(this.clients[this.editedIndex], client);
                this.resetForm();
                this.close();
              }
              loader.hide();
            })
            .catch(({ response }) => {
              this.formInvalidMessage = response.data.message;
              this.formInvalid = true;
              loader.hide();
            });
        } else {
          ApiService.post("clients/add", this.editedItem)
            .then(({ data }) => {
              if (data.client) {
                this.clients.splice(0, 0, data.client);
                this.resetForm();
                this.close();
              }
              loader.hide();
            })
            .catch(({ response }) => {
              const status = response && response.status;
              const payload = (response && response.data) ? response.data : {};
              if (status === 409 && payload && payload.code === 'CLIENT_EXISTS') {
                const client = payload.client || {};
                const name = client.CompanyName || 'Unbekannter Kunde';
                const kNr = client.Customer_ID || '-';
                Swal.fire({
                  icon: 'warning',
                  title: 'Kundenummer existiert bereits',
                  html: `<div style="text-align:left">` +
                        `<p>${payload.message || 'Ein Kunde mit dieser Kundennummer existiert bereits.'}</p>` +
                        `<p>Kunde: <strong>${name}</strong></p>` +
                        `<p>Kundennummer: <strong>${kNr}</strong></p>` +
                        `</div>`,
                  confirmButtonText: 'OK',
                  heightAuto: false
                });
                this.formInvalidMessage = payload.message || 'Ein Kunde mit dieser Kundennummer existiert bereits.';
                this.formInvalid = true;
              } else {
                this.formInvalidMessage = (payload && payload.message) || 'Speichern fehlgeschlagen. Bitte prüfen Sie Ihre Eingaben.';
                this.formInvalid = true;
              }
              loader.hide();
            });
        }
      } else this.formInvalid = true;
    },
    toClientItems(item) {
      //this.$router.push("/dashboard/schedules");
      this.$router.push({
        name: "clientsitems",
        params: { client_id: item.id, company_client: item },
        pathToRegexpOptions: { strict: true }
      });

      //history.pushState({}, null, this.$route.path + "/items/");
    },
    resetForm() {
      this.formInvalid = false;
      this.editedItem = createEmptyClient();
    },
    loadFixedTexts() {
      ApiService.query("fixed-texts")
        .then(({ data }) => {
          this.fixedTextOptions = data.data || [];
        })
        .catch(() => {
          this.fixedTextOptions = [];
        });
    },
    getHeaders(headingText) {
      return [
        {
          text: "Dynamic heading no. " + headingText,
          align: "left",
          sortable: false,
          value: "name"
        }
      ];
    },
    setActiveTab1(event) {
      this.tabIndex = this.setActiveTab(event);
    },
    setActiveTab2(event) {
      this.tabIndex2 = this.setActiveTab(event);
    },
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      // get all tab links
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set current active tab
      event.target.classList.add("active");

      // set clicked tab index to bootstrap tab
      return parseInt(event.target.getAttribute("data-tab"));
    },
    getCurrentYear() {
      return new Date().getFullYear();
    },
    openStatsDialog(item) {
      this.statsClient = item;
      const preferred = item && item.report_frequency ? item.report_frequency : "month";
      this.statsBreakdown = preferred === "week" ? "week" : "month";
      const currentYear = this.getCurrentYear();
      this.statsYear = currentYear < this.statsYearStart ? this.statsYearStart : currentYear;
      this.statsDialog = true;
    },
    closeStatsDialog() {
      this.statsDialog = false;
    },
    async confirmStatsDownload() {
      if (!this.statsClient) {
        this.statsDialog = false;
        return;
      }
      const year = parseInt(this.statsYear, 10);
      if (!year || year < this.statsYearStart) {
        Swal.fire({
          icon: "error",
          title: "Jahr ungültig",
          text: `Bitte ein Jahr ab ${this.statsYearStart} auswählen.`,
          heightAuto: false
        });
        return;
      }
      const breakdown = this.statsBreakdown === "week" ? "week" : "month";
      const format = this.statsFormat === "xlsx" ? "xlsx" : "pdf";
      const item = this.statsClient;
      this.statsDialog = false;
      await this.downloadStats(item, breakdown, year, format);
    },
    async downloadStats(item, breakdown, year, format) {
      this.isLoading = true;
      try {
        const clientId = item.id;
        const base = "/statistics/export";
        const resolvedYear = year || this.getCurrentYear();
        const breakdownLabel = breakdown === "week" ? "woche" : "monat";
        const resolvedFormat = format === "xlsx" ? "xlsx" : "pdf";
        const formatLabel = resolvedFormat === "xlsx" ? "xlsx" : "pdf";
        const formatMime = resolvedFormat === "xlsx"
          ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          : "application/pdf";
        const endpoint = `${base}?client_id=${clientId}&year=${resolvedYear}&breakdown=${breakdown}&format=${resolvedFormat}&t=${Date.now()}`; // Cache-Buster

        // Wie bei getPDFDraft: Binär abrufen (ArrayBuffer/Blob)
        const response = await ApiService.getFile(endpoint);
        const headers = (response && response.headers) ? response.headers : {};
        const contentType = headers["content-type"] || headers["Content-Type"] || "";
        const isJson = contentType.includes("application/json");
        const isExpectedFile =
          contentType.includes(formatMime) ||
          contentType.includes("application/octet-stream") ||
          (resolvedFormat === "xlsx" && contentType.includes("application/vnd.ms-excel"));

        if (isExpectedFile && !isJson) {
          const data = (response.data instanceof Blob)
            ? response.data
            : new Blob([response.data], { type: formatMime });

          const safeName = (item.CompanyName || "kunde")
            .toString()
            .replace(/\s+/g, "_")
            .replace(/[^a-zA-Z0-9_\-äöüÄÖÜß]/g, "")
            .substring(0, 60);
          const filename = `artikel_statistik_${resolvedYear}_${breakdownLabel}_${safeName}.${formatLabel}`;

          const url = URL.createObjectURL(data);
          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
          return;
        }

        // JSON- oder Fehlertext anzeigen
        if (isJson) {
          const decoder = new TextDecoder("utf-8");
          const txt = decoder.decode(new Uint8Array(response.data));
          try {
            const j = JSON.parse(txt);
            const msg = j.detail || j.error || j.message || "Die Datei konnte nicht heruntergeladen werden.";
            throw new Error(msg);
          } catch (_) {
            throw new Error("Die Datei konnte nicht heruntergeladen werden.");
          }
        }

        // Fallback: direkter fetch mit Blob
        const acceptHeader = resolvedFormat === "xlsx"
          ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream"
          : "application/pdf, application/octet-stream";
        const f = await fetch(endpoint, { headers: { Accept: acceptHeader }, credentials: "include" });
        const ct = f.headers.get("content-type") || "";
        const blob = await f.blob();
        const okFallback =
          ct.includes(formatMime) ||
          ct.includes("application/octet-stream") ||
          (resolvedFormat === "xlsx" && ct.includes("application/vnd.ms-excel"));
        if (!okFallback || blob.size < 1000) {
          const txt = await blob.text();
          let msg = "Die Datei konnte nicht heruntergeladen werden.";
          try { const j = JSON.parse(txt); msg = j.detail || j.error || msg; } catch (_) { if (txt) msg = txt.slice(0, 400); }
          throw new Error(msg);
        }

        const safeName = (item.CompanyName || "kunde")
          .toString()
          .replace(/\s+/g, "_")
          .replace(/[^a-zA-Z0-9_\-äöüÄÖÜß]/g, "")
          .substring(0, 60);
        const filename = `artikel_statistik_${resolvedYear}_${breakdownLabel}_${safeName}.${formatLabel}`;
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "Export fehlgeschlagen",
          text: e && e.message ? e.message : "Die Datei konnte nicht heruntergeladen werden.",
          heightAuto: false
        });
      } finally {
        this.isLoading = false;
      }
    },
  }
};
</script>
